import Vue from 'vue'
import Vuex from 'vuex'
import Global from './modules/Global'
import Session from './modules/Session'
import Users from './modules/Users'
import AccountSettings from './modules/AccountSettings'
import Surveys from './modules/Surveys'
import SurveyVersions from './modules/SurveyVersions'
import Drafts from './modules/Drafts'
import AuditObjects from './modules/AuditObjects'
import TestObjects from './modules/TestObjects'
import Deficiencies from './modules/Deficiencies'
import Audits from './modules/Audits'
import AuditEdit from './modules/AuditEdit'

import DatenpoolCategories from './modules/DatenpoolCategories'
import DatenpoolTags from './modules/DatenpoolTags'
import DatenpoolFiles from './modules/DatenpoolFiles'
import DatenpoolUpload from "./modules/DatenpoolUpload";

import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  plugins: debug ? [createLogger()] : [],
  modules: {
    Global,
    Session,
    Users,
    AccountSettings,
    Surveys,
    SurveyVersions,
    Drafts,
    AuditObjects,
    TestObjects,
    Deficiencies,
    Audits,
    AuditEdit,

    DatenpoolUpload,
    DatenpoolFiles,
    DatenpoolCategories,
    DatenpoolTags
  },
  strict: debug,
})



// WEBPACK FOOTER //
// ./src/store/index.js